import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { reducer as reduxFormReducer } from 'redux-form';
import { persistStore, persistReducer } from 'redux-persist';
import createCompressor from 'redux-persist-transform-compress';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import {
  authReducer,
  alertReducer,
  contactReducer,
  sidebarReducer,
  topBarReducer,
  themeReducer,
  rtlReducer,
  clientReducer,
  customFieldReducer,
  notificationReducer,
  tagReducer,
  stateReducer,
  documentReducer,
  notificationReviewReducer,
  resultReducer,
  layoutReducer,
  calendarReducer,
  emailReducer,
  clientAccessManagerReducer,
} from '../../redux/reducers/index';

import { syncClientDocumentsMiddleware } from '../../redux/middlewares/syncClientDocuments';

const reducer = combineReducers({
  auth: authReducer,
  alertState: alertReducer,
  contact: contactReducer,
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  sidebar: sidebarReducer,
  topBar: topBarReducer,
  rtl: rtlReducer,
  clientState: clientReducer,
  customField: customFieldReducer,
  notification: notificationReducer,
  tagState: tagReducer,
  documentState: stateReducer,
  document: documentReducer,
  notificationReview: notificationReviewReducer,
  results: resultReducer,
  layout: layoutReducer,
  calendar: calendarReducer,
  email: emailReducer,
  clientAccessManager: clientAccessManagerReducer,
});

const compressor = createCompressor({ whitelist: ['theme', 'auth'] });

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
  whitelist: ['theme', 'auth', 'layout', 'calendar', 'topBar', 'notification'],
  transforms: [
    encryptTransform({
      secretKey: window.REACT_APP_SK_STATES,
      onError: (error) => {
        console.error('redux persist encrypt error: ', error);
      },
    }),
    compressor,
  ],
};

const persistedReducer = persistReducer(persistConfig, reducer);

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunk),
  applyMiddleware(syncClientDocumentsMiddleware)
  // other store enhancers if any
);

const store = createStore(persistedReducer, enhancer);

const persistor = persistStore(store);

export { store, persistor };
